import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faTrophy, faDumbbell, faUtensils, faCut, faHorse } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from './../../assets/SainikSchoolGothra.png';

const SainikSchoolGothraTappaKhori = () => {
    const facilities = [
        { name: 'Gymnasium', icon: faDumbbell },
        { name: 'Cafeteria', icon: faUtensils },
        { name: 'Barber Services', icon: faCut },
        { name: 'Horse Riding', icon: faHorse }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faSchool} className="me-2" />
                        Sainik School, Gothra Tappa Khori, Rewari
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <div className="mb-4">
                    <img 
                        src={img} 
                        alt="Sainik School Gothra" 
                        style={{
                            width: '100%',
                            height: '370px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
                        }}
                    />
                </div>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faSchool} className="me-2" />
                            About the School
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The foundation stone of Sainik School Rewari was laid down by the then Defence Minister at Gothra Tappa Khori, on 29 August 2008, and in this way, Sainik School Rewari emerged as the 24th Sainik School of the nation and the second Sainik School in Haryana. The Sainik School is affiliated to Central Board of Secondary Education (CBSE) curriculum. The School got its initial affiliation from CBSE for running secondary classes in the year 2012 and thereafter in 2014, its upgraded to Senior Secondary level.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The school has been established in South Haryana with the aim to provide best education to the wards of Defence personnel who have displayed their indomitable courage before enemies on the battlefield. The soldiers of Rewari have also made their invincible presence acknowledged in the battles of 1962, 1965, 1971, and 1999. With these values of Patriotism and Sacrifice, a new landmark was achieved in the history of Sainik Schools as well as Rewari.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The Memorandum of Agreement (MoA) for establishing Sainik School Rewari was signed between the Ministry of Defence and the State Govt in June 2008, and subsequently, regular classes for the first academic session commenced from 01 May 2009 with 81 ardent cadets.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                The motto of the school is <strong>'Gyan Sadbhavna Desh Bhakti'</strong> which denotes the three primary qualities that the cadets must imbibe.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                There is no sports infrastructure in the School as of now. The School is making makeshift arrangements for cadets in the areas earmarked for residential and nonresidential buildings. The sports infrastructure is planned in Phase III & IV for which the Adm Approval is still pending.
                            </p>
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faDumbbell} className="me-2" />
                            Facilities Available in School for Cadets
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="row">
                            {facilities.map((facility, index) => (
                                <div key={index} className="col-md-6 col-lg-3 mb-3">
                                    <div 
                                        className="p-3 text-center rounded"
                                        style={{
                                            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                            color: 'white',
                                            minHeight: '100px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 15px rgba(22,160,133,0.2)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,160,133,0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(22,160,133,0.2)';
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={facility.icon} 
                                            style={{ fontSize: '2rem', marginBottom: '10px' }}
                                        />
                                        <h6 className="mb-0 fw-bold">{facility.name}</h6>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faTrophy} className="me-2" />
                            Peerless Triumph
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                            Preparing the cadets for making a career in the Armed Forces as officers has always been the cherished goal of this institution. A total of 10 cadets out of 52 cleared the NDA Written exam and 03 out of them got recommended for SSB (NDA Course 150), a total of 10 cadets out of 52 cleared the NDA Written exam and 02 out of them got recommended for SSB (NDA Course 151), and a total of 12 cadets out of 43 cleared the NDA Written exam and 05 out of them got recommended for SSB (NDA Course 152).
                        </p>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default SainikSchoolGothraTappaKhori;
